import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";

class SiderBarMobileSubItem extends React.Component {
  render() {
    const { item, click } = this.props;
    return (
      <RouterLink
        className="flex-row-vertical-center sp-sub-nav-item"
        to={item.path}
        onClick={click}
      >
        {item.name}
      </RouterLink>
    );
  }
}

SiderBarMobileSubItem.propTypes = {
  item: PropTypes.shape({
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  click: PropTypes.func,
};

SiderBarMobileSubItem.defaultProps = {
  click: undefined,
};

export default SiderBarMobileSubItem;
